<!-- Add Panel Code -->
  <p-dialog id="Add" [(visible)]="Add" appendTo="body" height="auto" width="auto" (onHide)="isClickedOnce=false;this.closeDialog.emit(false);"
  [style]="{width: '78%', minWidth: '550px'}" [minY]="100" [maximizable]="true" minimizeIcon="pi pi-window-minimize"
    maximizeIcon="pi pi-window-maximize" closeIcon="pi pi-times" [modal]="false"  draggable="true"
    styleClass= "add-edit-form-dialog">
  <ng-template #header [style] = "{'font-size': '17.5px', 'color': '#1b1d1f'}">Add {{screenType}}</ng-template>
    <!-- TID Generator Button -->
      @if(showTIDGeneratorBtn){
      <div class="ui-grid-col-12 container text-right nopadding">
        <div class="col-lg-12">
          <label for="TIDGeneratorDialogBtn" class="nopadding">
            <button pButton id="TIDGeneratorDialogBtn" type="button" [disabled]="false" label="TID Generator" (click)="caisServiceService.isDisplayTIDGenerator = true;" class="button tid-generator-button btn-lg tid-generator-label p-button-text"></button>
          </label>
        </div>
      </div>
      }
    <!-- End of TID Generator Button -->
    @if(Add){
    <div class="ui-grid-col-12 container">
      <!-- Record Details -->
      @for(viewRow of screenDetails; track viewRow.ui_Field_Name + '-'+ $index) {
      <span [ngClass]="(addScreenNegotiatedFields.includes(viewRow.ui_Field_Name) ? 'notdisplay' : (viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4'))">
        <!-- Medium Fields -->
          @if(!viewRow.isLargeField){
          <span>
            <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
              <div [ngClass]="'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
                <label for="ViewRow">{{viewRow.ui_Field_Name}}</label>
                @if(viewRow.isrequired){
                <strong class="error-mark">*</strong>
                }
              </div>
              <div [ngClass]="'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
                @if(!yearField.includes(viewRow.ui_Field_Name)){
                <span>
                  @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                  <ng-container>
                    <input pInputText [id]="viewRow.field_Name+'string'" [(ngModel)]="viewRow.value" [disabled]="viewRow.isDisable" [title]="(viewRow.placeholder ? viewRow.placeholder : '')" 
                    [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" [attr.data-multiEditDisabled]="viewRow.isMultiDisabled" autocomplete="off" [maxlength]="viewRow.maximumLength" 
                    [ngClass]="viewRow.error ? 'errorField' : ''" (keyup)="setTIDType(viewRow.field_Name);" (ngModelChange)="AutoGenerateTID($event, viewRow.field_Name)" />
                    <span [ngClass]="viewRow.error ? 'text-error' : ''">{{viewRow.error}}</span>
                  </ng-container>
                  }
                  @if((viewRow?.datatype | lowercase) === 'date'){
                  <ng-container>
                    <p-datepicker inputId="dtadd" [touchUI]="true" [(ngModel)]="viewRow.value" dateFormat="yy-mm-dd" [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" 
                      appendTo="body" [disabled]="viewRow.isDisable" [readonlyInput]="false" 
                      [ngClass]="viewRow.error ? 'errorDateField' : ''" [motionOptions]="{ duration: 0 }">
                    </p-datepicker>
                    <span [ngClass]="viewRow.error ? 'text-error' : ''">{{viewRow.error}}</span>
                  </ng-container>
                  }
                  @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'singleselect'){
                  <ng-container>
                    <p-select styleClass ="form-dropdown" appendTo="body" [name]="viewRow.field_Name +'singleselect'" [id]="viewRow.field_Name+'singleselect'" [title]="(viewRow.value ? viewRow.value : '')" 
                      [options]="viewRow.dropdownvalue" [(ngModel)]="viewRow.value" [showClear]="true" [disabled]="isDisabled(viewRow)" (onChange)="onChangeSelectionBox(viewRow)" 
                      [placeholder]="'Enter Value'" class="maxChoiceWidth" [ngClass]="viewRow.error ? 'errorDropdownField' : ''"
                      (ngModelChange)="AutoGenerateTID($event, viewRow.field_Name)" (onChange)="openTIDGenratePopUp(viewRow.field_Name)">
                    </p-select>
                    <span [ngClass]="viewRow.error ? 'text-error' : ''">{{viewRow.error}}</span>
                  </ng-container>
                  }
                </span>
                }
                @if(yearField.includes(viewRow.ui_Field_Name)){
                <span>
                  <input pInputText inputId="birthYear" class="birthYear" [id]="viewRow.field_Name" [(ngModel)]="viewRow.value" [disabled]="viewRow.isDisable" autocomplete="off"
                    [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" [maxlength]="viewRow.maximumLength" [ngClass]="viewRow.error ? 'errorDateField' : ''" 
                    (keyup)="maskYear()" (focus)="unMaskYear(viewRow.value)" (focusout)="maskYear()" />
                    <span [ngClass]="viewRow.error ? 'text-error' : ''">{{viewRow.error}}</span>
                </span>
                }
              </div>
            </div>
          </span>
          }
        <!-- End of Medium Fields -->
        <!-- Large Fields -->
          @if(viewRow.isLargeField){            
          <span>
            <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
              <div [ngClass]="'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg'">
                <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                @if(viewRow.isrequired){
                <strong class="error-mark">*</strong>
                }
              </div>
              <div [ngClass]="'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg'">
                <span>
                  @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                  <ng-container>
                    <input pInputText [id]="viewRow.field_Name+'string'" [(ngModel)]="viewRow.value" [disabled]="viewRow.isDisable" [title]="(viewRow.value ? viewRow.value : '')" 
                    [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" autocomplete="off" [maxlength]="viewRow.maximumLength" 
                    [ngClass]="viewRow.error ? 'errorField' : ''" />
                    <span [ngClass]="viewRow.error ? 'text-error' : ''">{{viewRow.error}}</span>
                  </ng-container>
                  }
                </span>
              </div>
            </div>
          </span>
          }
        <!-- End of Large Fields -->
      </span>
      }
    </div>
    }
    <!-- Address Details -->
    <div class="ui-grid-col-12 container">
      @if(AddressDetails.length > 0) {
        <p-table [id]="'addAddressTable'" [columns]="addressColumns" [value]="AddressDetails" class="AddressTable" #add_dt>
          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                @for(col of columns; track col.field + '-'+ $index) {
                <col style="min-width: 120px;">
                }
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th id="colActionHeader"></th>
              @for(col of columns; track col.field + '-'+ $index) {
              <th id="colHeader">
                {{col.header}}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-columns="columns" let-rowData let-ri="rowIndex">
            <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="ri">
              @if((AddressDetails.length === (ri+1))){
                <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="AddressDetails.push({'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''});"><em class="pi pi-plus"></em></a></td>
                }
                @if((AddressDetails.length !== (ri+1))){
                <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="AddressDetails.splice(ri,1);"><em class="pi pi-minus"></em></a></td>
                }
              @for(col of columns; track col.field + '-'+ $index) {
              <td pEditableColumn [ngClass]="{'errorFieldBorderBottom':(rowData['errorFields'] && rowData['errorFields'][col.field]), 'text-center':(['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field)), 'text-left':(!['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field))}">
                @if(!['Action','addr_regionCode', 'addr_countryCode'].includes(col.field)){
                <p-cellEditor>
                  <ng-template pTemplate="input">
                      <input pInputText type="text" [(ngModel)]="rowData[col.field]" [maxlength]="col.maxlength" [disabled]="col.disabled">
                  </ng-template>
                  <ng-template pTemplate="output">
                      {{rowData[col.field]}}
                  </ng-template>
                </p-cellEditor>
                }
                <!-- Country & Region Code Menu List -->
                @if(['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                <p-select styleClass ="form-dropdown justify-center table-column-dropdown"
                  appendTo="body" [options]="col.dropdownvalue" [(ngModel)]="rowData[col.field]" [showClear]="true" [filter]="true" [disabled]="col.disabled" 
                  [placeholder]="'Enter Value'" class="maxChoiceWidth" (ngModelChange)="rowData['addr_countryCode'] = ((['addr_regionCode'].includes(col.field) && rowData['addr_regionCode'] && (!rowData['addr_countryCode'] || ['US', 'CA'].includes(rowData['addr_countryCode']))) ? rowData['addr_regionCode'].slice(0,2) : rowData['addr_countryCode'])">
                </p-select>
                }
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
      }
    </div>
    <ng-template #footer>
      <div class="ui-dialog-buttonpane ui-helper-clearfix">
        <p-button class="add-edit-footer-button" type="button" icon="fa fa-close" id="Close" (click)="Add=false;isClickedOnce=false;this.closeDialog.emit(false);" label="Close">
        </p-button>
        <p-button class="add-edit-footer-button" type="button" icon="fa fa-check" id="addSave" (click)="addNewRecord()" [disabled]="isClickedOnce" label="Save">
        </p-button>
      </div>
    </ng-template>
  </p-dialog>
<!-- End of Adding Panel Code -->

<!-- Edit Panel Code -->
  <p-dialog id="Edit" [(visible)]="Edit" appendTo="body" height="auto" width="auto" (onHide)="isClickedOnce=false;this.closeDialog.emit(false);"
  [style]="{width: '78%', minWidth: '550px'}" [minY]="100" [maximizable]="true" minimizeIcon="pi pi-window-minimize"
    maximizeIcon="pi pi-window-maximize" closeIcon="pi pi-times" [modal]="false" draggable="true"
    styleClass= "add-edit-form-dialog">
   <ng-template #header [style] = "{'font-size': '17.5px', 'color': '#1b1d1f'}">Edit {{screenType}}</ng-template>
    <!-- TID Generator Button -->
      @if(showTIDGeneratorBtn || showTIDUpdateBtn){     
      <div class="ui-grid-col-12 container text-right nopadding">
        <div class="col-lg-12">
          @if(showTIDGeneratorBtn){
          <label class="nopadding" for="TIDGeneratorDialogBtn">
            <button pButton id="TIDGeneratorDialogBtn" type="button" [disabled]="false" label="TID Generator" (click)="caisServiceService.isDisplayTIDGenerator = true;" class="button btn-lg tid-generator-button tid-generator-label p-button-text"></button>
          </label>
          }
        </div>
      </div>
      }
    <!-- End of TID Generator Button -->
    @if(Edit){
    <div class="ui-grid-col-12 container">
      <!-- Record Details -->
      @for(viewRow of screenDetails; track viewRow.ui_Field_Name + '-'+ $index) {
      <span [ngClass]="(editScreenNegotiatedFields.includes(viewRow.ui_Field_Name) ? 'notdisplay' : (viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4'))">
        <!-- Medium Fields -->
          @if(!viewRow.isLargeField){
          <span>
            <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
              <div [ngClass]="'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
                <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                @if(viewRow.isrequired){
                <strong class="error-mark">*</strong>
                }
              </div>
              <div [ngClass]="'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
                @if(!yearField.includes(viewRow.ui_Field_Name)){
                <span>
                  @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                  <ng-container>
                    <input pInputText [id]="viewRow.field_Name+'string'" [(ngModel)]="viewRow.value" [disabled]="viewRow.isDisable" [title]="(viewRow.placeholder ? viewRow.placeholder : '')" 
                      [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" [attr.data-multiEditDisabled]="viewRow.isMultiDisabled" autocomplete="off" [maxlength]="viewRow.maximumLength" 
                      [ngClass]="viewRow.error ? 'errorField' : ''" />
                      <span [ngClass]="viewRow.error ? 'text-error' : ''">{{viewRow.error}}</span>
                  </ng-container>
                  }
                  @if((viewRow?.datatype | lowercase) === 'date'){
                  <ng-container>
                    <p-datepicker inputId="dpedit" [touchUI]="true" [(ngModel)]="viewRow.value" dateFormat="yy-mm-dd" [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" 
                      showButtonBar="true" appendTo="body" [disabled]="viewRow.isDisable" [readonlyInput]="false" 
                      [ngClass]="viewRow.error ? 'errorDateField' : ''" [motionOptions]="{ duration: 0 }">
                    </p-datepicker>
                    <span [ngClass]="viewRow.error ? 'text-error' : ''">{{viewRow.error}}</span>
                  </ng-container>
                  }
                  @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'yes' && (viewRow?.dropdowntype | lowercase) === 'singleselect'){
                  <ng-container>
                    <p-select styleClass ="form-dropdown" appendTo="body" [name]="viewRow.field_Name +'singleselect'" [id]="viewRow.field_Name+'singleselect'" [title]="(viewRow.value ? viewRow.value : '')" 
                      [options]="viewRow.dropdownvalue" [(ngModel)]="viewRow.value" [showClear]="true" [disabled]="isDisabled(viewRow)" (onChange)="onChangeSelectionBox(viewRow)" 
                      [placeholder]="'Enter Value'" class="maxChoiceWidth" [ngClass]="viewRow.error ? 'errorDropdownField' : ''"  (onChange)="openTIDGenratePopUp(viewRow.field_Name)">
                    </p-select>
                    <span [ngClass]="viewRow.error ? 'text-error' : ''">{{viewRow.error}}</span>
                  </ng-container>
                  }
                </span>
                }
                @if(yearField.includes(viewRow.ui_Field_Name)){
                <span>
                  <input pInputText inputId="birthYear" class="birthYear" [id]="viewRow.field_Name" [(ngModel)]="viewRow.value" [disabled]="viewRow.isDisable" autocomplete="off" 
                    [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" [maxlength]="viewRow.maximumLength" [ngClass]="viewRow.error ? 'errorDateField' : ''" 
                    (keyup)="maskYear()" (focus)="unMaskYear(viewRow.value)" (focusout)="maskYear()" />
                    <span [ngClass]="viewRow.error ? 'text-error' : ''">{{viewRow.error}}</span>
                </span>
                }
              </div>
            </div>
          </span>
          }
        <!-- End of Medium Fields -->
        <!-- Large Fields -->
          @if(viewRow.isLargeField){
          <span>
            <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
              <div [ngClass]="'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg'">
                <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                @if(viewRow.isrequired){
                <strong class="error-mark">*</strong>
                }
              </div>
              <div [ngClass]="'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg'">
                <span>
                  @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                  <ng-container>
                    <input pInputText [id]="viewRow.field_Name+'string'" [(ngModel)]="viewRow.value" [disabled]="viewRow.isDisable" [title]="(viewRow.value ? viewRow.value : '')" 
                    [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')" autocomplete="off" [maxlength]="viewRow.maximumLength" 
                    [ngClass]="viewRow.error ? 'errorField' : ''" />
                    <span [ngClass]="viewRow.error ? 'text-error' : ''">{{viewRow.error}}</span>
                  </ng-container>
                  }
                </span>
              </div>
            </div>
          </span>
          }
        <!-- End of Large Fields -->
      </span>
      }
    </div>
    }
    
    <!-- Address Details -->
    <div class="ui-grid-col-12 container">
      @if(AddressDetails.length > 0) {
        <p-table [id]="'editAddressTable'" [columns]="addressColumns" [value]="AddressDetails" class="AddressTable" #edit_dt>
          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              @for(col of columns; track col.field + '-'+ $index) {
                <col style="min-width: 120px;">
              }  
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th id="colEditActionHeader"></th>
              @for(col of columns; track col.header + '-'+ $index) {
              <th id="colHeader">
                {{col.header}}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-columns="columns" let-rowData let-ri="rowIndex">
            <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="ri">
              @if((AddressDetails.length === (ri+1))){
                <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="AddressDetails.push({'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''});"><em class="pi pi-plus"></em></a></td>
                }
                @if((AddressDetails.length !== (ri+1))){
                <td class="text-center"><a [ngClass]="{'disabledLink': true}" (click)="AddressDetails.splice(ri,1);"><em class="pi pi-minus"></em></a></td>
                }
              @for(col of columns; track col.field + '-'+ $index) {
              <td pEditableColumn [ngClass]="{'errorFieldBorderBottom':(rowData['errorFields'] && rowData['errorFields'][col.field]), 'text-center':(['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field)), 'text-left':(!['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field))}">
                @if(!['Action','addr_regionCode', 'addr_countryCode'].includes(col.field)){
                <p-cellEditor>
                  <ng-template pTemplate="input">
                      <input pInputText type="text" [(ngModel)]="rowData[col.field]" [maxlength]="col.maxlength" [disabled]="col.disabled">
                  </ng-template>
                  <ng-template pTemplate="output">
                      {{rowData[col.field]}}
                  </ng-template>
                </p-cellEditor>
                }
                <!-- Country & Region Code Menu List -->
                @if(['addr_regionCode', 'addr_countryCode'].includes(col.field)){               
                <p-select styleClass ="form-dropdown justify-center table-column-dropdown"
                  appendTo="body" [options]="col.dropdownvalue" [(ngModel)]="rowData[col.field]" [showClear]="true" [filter]="true" [disabled]="col.disabled" 
                  [placeholder]="'Enter Value'" class="maxChoiceWidth" (ngModelChange)="rowData['addr_countryCode'] = ((['addr_regionCode'].includes(col.field) && rowData['addr_regionCode'] && (!rowData['addr_countryCode'] || ['US', 'CA'].includes(rowData['addr_countryCode']))) ? rowData['addr_regionCode'].slice(0,2) : rowData['addr_countryCode'])">
                </p-select>
                }
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
      }
    </div>
    <ng-template #footer>
      <div class="ui-dialog-buttonpane ui-helper-clearfix">
        <p-button class="add-edit-footer-button" type="button" icon="fa fa-close" id="Close" (click)="Edit=false;isClickedOnce=false;this.closeDialog.emit(false);" label="Close">
        </p-button>
        <p-button class="add-edit-footer-button" type="button" icon="fa fa-check" id="editSave" (click)="editRecord();" [disabled]="isClickedOnce" label="Save">
        </p-button>
      </div>
    </ng-template>
  </p-dialog>
<!-- End of Editing Panel Code -->

<!-- Quick View Panel Code -->
<p-dialog id="View" [(visible)]="View" appendTo="body" height="auto" width="auto" (onHide)="this.closeDialog.emit(false);"
[style]="{width: '78%', minWidth: '550px'}" [minY]="100" [maximizable]="true" minimizeIcon="pi pi-window-minimize"
  maximizeIcon="pi pi-window-maximize" closeIcon="pi pi-times" [modal]="false" draggable="true" [focusOnShow]="false"
  styleClass= "add-edit-form-dialog">
 <ng-template #header [style] = "{'font-size': '17.5px', 'color': '#1b1d1f'}">View {{screenType}}</ng-template>
  @if(View){
  <div class="ui-grid-col-12 container">
    <!-- Record Details -->
    @for(viewRow of screenDetails; track viewRow.ui_Field_Name + '-'+ $index) {
    <span [ngClass]="(viewScreenNegotiatedFields.includes(viewRow.ui_Field_Name) ? 'notdisplay' : (viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4'))">
      <!-- Medium Fields -->
        @if(!viewRow.isLargeField){        
        <span>
          <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
            <div [ngClass]="'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
              <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
            </div>
            <div [ngClass]="'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
              @if(!yearField.includes(viewRow.ui_Field_Name)){
              <span>
                @if((viewRow?.datatype | lowercase) !== 'date'){
                <ng-container>
                  <input [disabled]="true" pInputText [(ngModel)]="viewRow.value" [title]="(viewRow.value ? viewRow.value : '')" />
                </ng-container>
                }
                @if((viewRow?.datatype | lowercase) === 'date'){
                <ng-container>
                  <input [disabled]="true" pInputText [value]="getFormat(viewRow.value)" [title]="(viewRow.value ? viewRow.value : '')" />
                </ng-container>
                }
              </span>
              }
              @if(yearField.includes(viewRow.ui_Field_Name)){
              <span>
                <input [readOnly]="true" pInputText inputId="birthYear" class="birthYear" [id]="viewRow.field_Name" [(ngModel)]="viewRow.value" [disabled]="viewRow.isDisable" 
                  (keyup)="maskYear()" (focus)="unMaskYear(viewRow.value)" (focusout)="maskYear()" />
              </span>
              }
            </div>
          </div>
        </span>
        }
      <!-- End of Medium Fields -->
      <!-- Large Fields -->
        @if(viewRow.isLargeField){
        <span>
          <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
            <div [ngClass]="'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg'">
              <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
            </div>
            <div [ngClass]="'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg'">
              <span>
                @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                <ng-container>
                  <input [disabled]="true" pInputText [(ngModel)]="viewRow.value" [title]="(viewRow.value ? viewRow.value : '')" />
                </ng-container>
                }
              </span>
            </div>
          </div>
        </span>
        }
    <!-- End of Large Fields -->
    </span>
    }
  </div>
  }
  <!-- Address Details -->
  <div class="ui-grid-col-12 container">
    <p-table class="form-table" [id]="'viewAddressTable'" [columns]="addressColumns" [value]="AddressDetails" #dt2>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for(col of columns; track col.header + '-'+ $index) {
          <th id="colHeader" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
            {{col.header}}
          </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-addressRowData let-ri="rowIndex" let-columns="columns">
        <tr [pSelectableRow]="addressRowData">
          @for(col of columns; track col.field + '-'+ $index) {
          <td [ngClass]="(['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field) ? 'text-center' : 'text-left')">
            <span>
              {{addressRowData[col.field]}}
            </span>
          </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
  <!-- End of Address Details -->
    <ng-template #footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <p-button class="add-edit-footer-button" type="button" icon="fa fa-close" id="Close" (click)="View=false;this.closeDialog.emit(false);" label="Close">
      </p-button>
    </div>
    </ng-template>
</p-dialog>

<!-- TID Generator -->
<app-tid-generator></app-tid-generator>